import { z } from "zod";
import { sourceLinkSchema, tagSchema, officialBadgeSchema } from "./place";

export const eventPlaceRefSchema = z.object({
  id: z.string(), name: z.string(), addressLine: z.string(),
  latitude: z.number().optional(), longitude: z.number().optional(),
});
export const eventSchema = z.object({
  id: z.string(),
  name: z.string(),
  summary: z.string().nullable().optional(),
  eventType: z.string().nullable().optional(),
  startsAt: z.string(),
  endsAt: z.string(),
  bookingStartsAt: z.string().nullable().optional(),
  priceSummary: z.string().nullable().optional(),
  status: z.string(),
  verificationStatus: z.string(),
  reservationRequired: z.boolean(),
  officialBadge: officialBadgeSchema.nullable().optional(),
  tags: z.array(tagSchema).optional(),
  sourceLinks: z.array(sourceLinkSchema).optional(),
  places: z.array(eventPlaceRefSchema).optional(),
});
export type EventDto = z.infer<typeof eventSchema>;
